// The ceiling as the property form records it (owner model, 2026-09-16).
//
//   ceiling_height      the reported height — its historical meaning, never "the minimum"
//   ceiling_variation   'uniform' | 'varies'; '' = not stated (a plain "2.8 m" proves neither)
//   ceiling_height_min / ceiling_height_max   only when it varies
//
// Server twin: core/migrations/1196 (property_ceiling_v1, retract_own_claims by concept) and the
// rolled-back scenarios in core/parity/ceiling-canonical-scenarios.sql. The rule this file exists to
// hold: what the agent SEES after reopening is exactly what is stored — no stale range under a
// "same everywhere", no stale single height under a "varies".

// Both ends typed and the lowest is not below the highest: held back from the save, named in the form.
export function ceilingRangeBad(facts) {
  const f = facts || {}
  return f.ceiling_variation === 'varies' && f.ceiling_height_min !== '' && f.ceiling_height_min != null
    && f.ceiling_height_max !== '' && f.ceiling_height_max != null
    && !(Number(f.ceiling_height_min) < Number(f.ceiling_height_max))
}

// The select's change: leaving "varies" empties the range, so its claims are retracted on save.
export function withCeilingVariation(facts, variation) {
  return { ...facts, ceiling_variation: variation, ...(variation !== 'varies' && { ceiling_height_min: '', ceiling_height_max: '' }) }
}

const num = v => (v === '' || v == null || !Number.isFinite(Number(v)) ? undefined : Number(v))

// The four ceiling fields of the save payload; undefined = not sent.
export function ceilingPayload(facts, { isLand = false } = {}) {
  const f = facts || {}
  if (isLand) return { ceiling_height: undefined, ceiling_variation: undefined, ceiling_height_min: undefined, ceiling_height_max: undefined }
  const varies = f.ceiling_variation === 'varies'
  const bad = ceilingRangeBad(f)
  return {
    // a known range is not collapsed into one number
    ceiling_height: varies ? undefined : num(f.ceiling_height),
    ceiling_variation: f.ceiling_variation || undefined,
    ceiling_height_min: !varies || bad ? undefined : num(f.ceiling_height_min),
    ceiling_height_max: !varies || bad ? undefined : num(f.ceiling_height_max),
  }
}

// Claims of THEIRS the save must retract beyond the fields they emptied (clearedOwnKeys covers those):
//   "varies" → their own single height steps aside, it is not left standing beside the range;
//   anything else → their own min/max go, even if the form never showed them (a reopened stale range).
export function ceilingRetracts(facts, ownKeys, { isLand = false } = {}) {
  if (isLand) return []
  const own = new Set(ownKeys || [])
  const f = facts || {}
  if (f.ceiling_variation === 'varies') return own.has('ceiling_height') ? ['ceiling_height'] : []
  return ['ceiling_height_min', 'ceiling_height_max'].filter(k => own.has(k))
}
